import { useMediaQuery } from '@material-ui/core';
import React, { useState } from 'react';
import { MUI_MOBILE_BREAKPOINT } from 'src/scripts/utils/constants';
import { observer } from 'mobx-react-lite';
import { bopisState, setStoreSelection } from '../Bopis/bopisState';
import { IStoreAvailabilityData } from './storeLocatorTypes';
import './style.scss';
import StockIndicator from '../StockIndicator/StockIndicator';
import AloRadioButton from 'src/scripts/templates/_shared/ui-components/YogaUI/AloRadioButton';

let StoreLocatorTile = ({
  store,
  inputName,
  isAvailableOnline,
  showFullTile = false,
  storeSelectionEnabled = false,
}: {
  store: IStoreAvailabilityData;
  inputName: string;
  isAvailableOnline: boolean;
  showFullTile?: boolean;
  storeSelectionEnabled?: boolean;
}) => {
  const [showDetails, setShowDetails] = useState(false);
  const toggleDetails = () => {
    setShowDetails((prevShowDetails) => !prevShowDetails);
  };
  const isMobile = useMediaQuery(MUI_MOBILE_BREAKPOINT, { noSsr: true });
  const textWhenAvailable = storeSelectionEnabled
    ? isAvailableOnline
      ? 'Available for pick up'
      : 'Available In Store'
    : 'In Stock';

  function trimNumbersFromString(name: string) {
    const trimmedString = name.replace(/\d+/g, '');
    return trimmedString.trim();
  }

  return (
    <div
      className={`store-locator-tile ${storeSelectionEnabled ? 'pointer-events-enabled' : ''}`}
      {...(storeSelectionEnabled && !isMobile ? { onClick: () => setStoreSelection([store]) } : {})}
    >
      <div className="store-locator-tile__first">
        <div
          className="store-locator-tile__column"
          {...(storeSelectionEnabled && isMobile ? { onClick: () => setStoreSelection([store]) } : {})}
        >
          <div className="store-locator-tile__title-column">
            {storeSelectionEnabled ? (
              <AloRadioButton
                label={trimNumbersFromString(store.name)}
                groupName={`selectedStore-${inputName}`}
                value={store.location_id}
                checked={bopisState.storeSelection?.[0]?.location_id === store.location_id || false}
              />
            ) : store.name ? (
              <p className="black-text">{trimNumbersFromString(store.name)}</p>
            ) : null}
          </div>
          <StockIndicator
            isAvailable={store.available_after_safety_stock > 0}
            textWhenAvailable={textWhenAvailable}
            textWhenUnavailable="Out of Stock"
          />
        </div>
        {showFullTile ? (
          isMobile ? (
            <button className="accordion-icon" type="button" onClick={toggleDetails}>
              {showDetails ? <span className="alo-subtract-icon"></span> : <span className="alo-add-icon"></span>}
            </button>
          ) : null
        ) : null}
      </div>
      {store.address && showFullTile && (
        <div className={`store-locator-tile__row ${isMobile && showDetails ? '' : 'hide'}`}>
          <span className="alo-location-pin-icon"></span>
          <div>
            <p>{store.address.address1 && store.address.address1}</p>
            <p>{store.address.address2 && store.address.address2}</p>
            <p>
              {store.address.city && <span>{store.address.city}</span>}
              {store.address.province_code && <span>, {store.address.province_code}</span>}
              {store.address.postal_code && <span> {store.address.postal_code}</span>}
            </p>
          </div>
        </div>
      )}
      {store.hours_of_operation.length > 0 && showFullTile ? (
        <div className={`store-locator-tile__row ${isMobile && showDetails ? '' : 'hide'}`}>
          <span className="alo-clock-icon"></span>
          <div>
            {store.hours_of_operation.map((row, index) => {
              return (
                <div className="store-locator-hours" key={index}>
                  <p className="store-locator-hours__row">{row.day_text}:</p>
                  <p className="store-locator-hours__row">{row.hour_text}</p>
                </div>
              );
            })}
          </div>
        </div>
      ) : showFullTile && !isMobile ? (
        <div className="store-locator-tile__row"> </div>
      ) : null}
    </div>
  );
};

StoreLocatorTile = observer(StoreLocatorTile);
export { StoreLocatorTile };
